import { useId, useState } from 'react';
import { Alert, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useCreateManualSource } from '../../../hooks/useSupport';
import '../Roles/roles.css';

/**
 * Pasted training text — an FAQ answer, or an example conversation showing the
 * tone support wants. Saving embeds this source immediately, so the assistant
 * knows it on the next message rather than after the next ingest run.
 *
 * Native fields: the shared MuiTextField override paints outlined fields dark
 * for the mobile app, which is unreadable on the dashboard.
 */
export function AddTrainingTextForm() {
  const { t } = useTranslation();
  const nameId = useId();
  const textId = useId();
  const [name, setName] = useState('');
  const [text, setText] = useState('');
  const { mutate, isPending, data } = useCreateManualSource();

  const canSubmit = name.trim().length > 0 && text.trim().length > 0;

  const submit = () => {
    if (!canSubmit) return;
    mutate({ name: name.trim(), text: text.trim() });
    setText('');
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem', maxWidth: 720 }}>
      <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
        {t('dashboard.kb.addTrainingTextTitle')}
      </Typography>

      <div className="role-form-field">
        <label htmlFor={nameId} className="role-form-label">
          {t('dashboard.kb.sourceName')}
        </label>
        <input
          id={nameId}
          type="text"
          className="filter-search-input"
          value={name}
          onChange={(event) => setName(event.target.value)}
          disabled={isPending}
        />
      </div>

      <div className="role-form-field">
        <label htmlFor={textId} className="role-form-label">
          {t('dashboard.kb.trainingText')}
        </label>
        <textarea
          id={textId}
          className="filter-search-input"
          rows={8}
          style={{ resize: 'vertical', fontFamily: 'inherit', lineHeight: 1.5 }}
          value={text}
          onChange={(event) => setText(event.target.value)}
          disabled={isPending}
        />
      </div>

      <button
        type="button"
        className="primary-action-btn"
        style={{ alignSelf: 'flex-start' }}
        onClick={submit}
        disabled={isPending || !canSubmit}
      >
        {t('dashboard.kb.save')}
      </button>

      {data && (
        <Alert severity={data.error ? 'error' : 'success'}>
          {data.error ?? t('dashboard.kb.embedded', { count: data.embedded })}
        </Alert>
      )}
    </div>
  );
}

export default AddTrainingTextForm;
